import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import markup from "ulysses/widgets/users.html";

"use strict";
$(document).ready(function() { $(markup).appendTo($("body")); });
function fetch_users(elt, obs) {
    $(elt).addClass("loader");
        var h_res = uly.api.start().follow("uly:users").follow("uly:liveusers", {"status":"active" }).follow("item").done(function(results) {
            if (results.length){
                results = $.map(results, function(val,idx) {
                    val.status = val.last_activity ? "online" : "offline";
                    return val;
                });
                obs(results);
            }else{
                obs([]);
            }
            $(elt).removeClass("loader");
        });
}
ko.bindingHandlers.users = {
    "init":function(elt, va, allbindings, model, context) {
        var users = ko.observableArray([]);
        $(elt).data("users", users);
        $(elt).html($("#users-compact-rows-tmpl").html());
        var interval = setInterval(function() {
            fetch_users(elt, users);
        }, 240000);
        ko.utils.domNodeDisposal.addDisposeCallback(elt, function() {
            clearInterval(interval);
        });
        ko.applyBindingsToDescendants(context.createChildContext({"users":users }), elt);
        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, allbindings, model, context) {
        var users = $(elt).data("users");
        fetch_users(elt, users);
    }
};
